import { render, staticRenderFns } from "./SelfStudyDashboard.vue?vue&type=template&id=28f48374&"
import script from "./SelfStudyDashboard.vue?vue&type=script&lang=js&"
export * from "./SelfStudyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports